module.exports = __webpack_public_path__ + "static/media/microblog.56364d52.svg";